import { getLang } from "../functions";

document.addEventListener("DOMContentLoaded", () => {
  if (typeof zE !== "undefined") {
    zE("webWidget", "setLocale", getLang);
  }
});
